import React from 'react'
import { Box, Chip } from '@mui/material'
import { poolwerxColors } from '../../../../theme/colors'

export interface ChipOption {
  label: string
  value: string
}

export interface ChipMultiSelectProps {
  options: ReadonlyArray<ChipOption>
  /** Currently-selected values. */
  value: string[]
  onChange: (value: string[]) => void
}

/**
 * Compact multi-select rendered as clickable teal chips. Toggling a chip adds
 * or removes its value. Reuses the chip-toggle pattern from UserForm; lives
 * here so any admin form can use it - see docs/development/admin-forms.md.
 */
const ChipMultiSelect: React.FC<ChipMultiSelectProps> = ({ options, value, onChange }) => {
  const toggle = (val: string) => {
    onChange(value.includes(val) ? value.filter((v) => v !== val) : [...value, val])
  }

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {options.map((opt) => {
        const selected = value.includes(opt.value)
        return (
          <Chip
            key={opt.value}
            label={opt.label}
            size="small"
            variant="outlined"
            onClick={() => toggle(opt.value)}
            sx={{
              cursor: 'pointer',
              fontWeight: selected ? 600 : 400,
              ...(selected
                ? {
                    bgcolor: poolwerxColors.tealLight,
                    borderColor: poolwerxColors.teal,
                    color: poolwerxColors.teal,
                    '&:hover': { bgcolor: poolwerxColors.tealLight },
                  }
                : {}),
            }}
          />
        )
      })}
    </Box>
  )
}

export default ChipMultiSelect
